<template>
  <div class="ex-not-found">
    <img src="../../assets/img/icons/search.svg" alt="">
    <h4>{{ title }}</h4>
    <p v-if="subTitle">{{ subTitle }}</p>
    <v-btn
      text
      :ripple="false"
      class="ma-0 ex-btn ex-simple-primary-btn disable-hover font-weight-600"
      @click="$emit('click')"
    >
      {{ reference }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  props: {
    reference: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/NotFound.vue